<!-- 快递运单 -->
<template>
  <div class="content">
    <div class="title">
      开启商家配送的商户需设置，在发货时可选用已添加的快递公司
    </div>
    <div class="cont">
      div.
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {}
}
</script>
<style lang= "scss" scoped>
  .content {
    width: 100%;
    height: 100%;
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 12px;
    }
  }
</style>